<div
  class="flex flex-col gap-9 mt-8"
  *ngIf="!loading()">
  <div class="flex items-center justify-between">
    <app-back-button />
    <div
      *ngIf="detail()"
      class="flex gap-4">
      <app-buttons
        [label]="'Rechazar'"
        [classes]="'text-primary-base'"
        (click)="reject()" />
      <app-buttons
        [label]="'Aceptar'"
        [classes]="'bg-primary-base text-primary-light'"
        (click)="accept()" />
    </div>
  </div>

  <ng-container *ngIf="detail() as usage; else errorState">
    <div class="text-4xl font-bold">{{ usage.usageName || '-' }}</div>

    <div class="flex items-center gap-3">
      <div
        class="w-4 h-4"
        [ngClass]="colorBox()"></div>
      <div class="text-md font-semibold">{{ stateTextFormat() }}</div>
      <span class="text-md text-neutral-dark">
        Creado el {{ usage.creationDate || '-' }}, por {{ usage.requestingPerson || '-' }}
      </span>
    </div>

    <section class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos del uso de solución IA</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">ID</span>
          <span class="text-[16px] font-normal">{{ usage.id || '-' }}</span>
        </div> -->

        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Tipo</span>
          <span class="text-[16px] font-normal">{{ usage.solutionType || '-' }}</span>
        </div>

        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Identificador del registro</span>
          <span class="text-[16px] font-normal">{{ usage.usageName || '-' }}</span>
        </div>
      </div>
    </section>

    <section class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos identificativos del uso de solución IA</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Persona solicitante</span>
          <span class="text-[16px] font-normal">{{ usage.requestingPerson || '-' }}</span>
        </div>

        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Correo de contacto</span>
          <span class="text-[16px] font-normal">{{ usage.requestingPersonEmail || '-' }}</span>
        </div>

        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Unidad Organizativa Solicitante</span>
          <span class="text-[16px] font-normal">{{ usage.organization || '-' }}</span>
        </div>

        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Departamento solicitante</span>
          <span class="text-[16px] font-normal">{{ usage.departmentName || '-' }}</span>
        </div>
      </div>
    </section>

    <section class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos funcionales de la solución IA</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-neutral-dark">Nombre</span>
          <span class="text-[16px] font-normal">{{ usage.solutionName || '-' }}</span>
        </div>

        <div class="flex flex-col md:col-span-2">
          <span class="text-sm text-neutral-dark">Finalidad</span>
          <span class="text-[16px] font-normal whitespace-pre-line">{{ usage.solutionDescription || '-' }}</span>
        </div>

        <div class="flex flex-col md:col-span-2">
          <span class="text-sm text-neutral-dark">Uso previsto</span>
          <span class="text-[16px] font-normal whitespace-pre-line">{{ usage.expectedUse || '-' }}</span>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template #errorState>
    <div class="flex flex-col gap-2">
      <span class="text-2xl font-bold">
        {{ notFound() ? 'Uso de solución IA no encontrado' : 'No se pudo cargar el detalle' }}
      </span>
      <span class="text-[16px] text-neutral-dark">
        {{ notFound() ? 'No existe un uso de solución IA con el identificador indicado.' : errorMessage() }}
      </span>
    </div>
  </ng-template>
</div>
